@if (organisationData.content.length > 0 || !!search) {
  <lgv-search-input placeholder="admin_organisation_search" (searchChanged)="onSearch($event)"></lgv-search-input>
}
@if (organisationData.content.length > 0 && !isLoading) {
  <lgv-generic-table
    [tableDataSubject]="organisationsTableChanged"
    [page]="page"
    [pageSize]="count"
    [totalCount]="totalCount"
    (updateRowEvent)="editClicked($event)"
    (deleteRowEvent)="deleteClicked($event)"
    (permissionRowEvent)="permissionClicked($event)"
    (pageChanged)="onPageChanged($event)"
  ></lgv-generic-table>
}

<lgv-fab-button (btnClicked)="addClicked()" type="add"></lgv-fab-button>

@if (organisationData.content.length === 0 && !isLoading && search) {
  <lgv-empty-state
    symbol="help"
    titleText="admin_organisation_notfound_title"
    text="admin_organisation_notfound_message"
  ></lgv-empty-state>
}

@if (organisationData.content.length === 0 && !isLoading && !search) {
  <lgv-empty-state
    symbol="add_circle"
    titleText="admin_organisation_init_title"
    text="admin_organisation_init_message"
  ></lgv-empty-state>
}
